module.exports = __webpack_public_path__ + "static/media/S1-31-Zardok-cod51.3c1be30e.png";